import Vue from 'vue'
import axios from '@/wrappers/axios.js'

const PointService = {

    pointList(params) {
        return new Promise(async (resolve, reject) => {
            axios
                .get(`/points${params ? params : ''}`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },

    createPoint(data) {
        return new Promise(async (resolve, reject) => {
            axios
                .post(`/points`, data)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },

    getPoint(id, params) {
        return new Promise(async (resolve, reject) => {
            axios
                .get(`/points/${id}${params ? params : ''}`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },

    updatePoint(id, data) {
        return new Promise(async (resolve, reject) => {
            axios
                .put(`/points/${id}`, data)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },
    delete(id) {
        return new Promise(async (resolve, reject) => {
            axios
                .delete(`/points/${id}`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    }
}

Vue.$pointService = PointService

export default PointService